import React, { Component } from 'react';

import { getLangData, getCurrentLangCode } from "../services/lang";
import EstateContent from '../model/estateContent';
import { getEstate } from '../services/strapiService';
import DOMPurify from 'dompurify';
import marked from 'marked';

class Estate extends Component<{}, EstateState> {

    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            estateContent: undefined,
        };
    }

    componentDidMount() {
        getEstate(getCurrentLangCode())
            .then((estateContent) => this.setState({
                estateContent: estateContent
            }));
    }

    render() {
        const langData = getLangData();
        const { estateContent } = this.state;
        if (estateContent === undefined) {
            return (
                <div className="container">
                    <div className="row mb-5">
                        <div className="col d-flex justify-content-center align-items-center">
                            <div className="spinner-border mr-3" role="status" />{langData.meta.isLoading}
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="container">
                <div className="row mb-5">
                    <div className="col">
                        <p className="h1 fw-300">{langData.estate.header}</p>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col">
                        <p dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(marked(estateContent.content))
                        }}></p>
                    </div>
                </div>
            </div>
        );
    }

}

type EstateState = {
    estateContent: EstateContent | undefined;
};

export default Estate;